import React from "react";

export const BioNote = () => {
  return (
    <div id="bioNote" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Biographical Note</h2>
          <div className="text-justify-xs">
            <br></br>
            <h3>Education</h3>
            <p>
              Faculty of Electrical Engineering and Computing, University of
              Zagreb:
            </p>
            <p>- 2004-2010: Ph.D., specialization in Computing Science</p>
            <p>
              - 1996-2000: M.Sc., specialization in Application of Computers in
              Medicine Ultrasound
            </p>
            <p>
              - 1990-1995:B.Sc., specialization Radio communications, Acoustics
              and Professional Electronics
            </p>
            <br></br>
            <h3>Employment</h3>
            <p>
              - 2006- : Faculty of Electrical Engineering, Mechanical
              Engineering and Naval Architecture, University of Split (Full
              Professor)
            </p>
            <p>- 2004-2009: SIKORA, Split (Owner)</p>
            <p>- 1996-2004: ENTER d.o.o., Split (GIS manager)</p>
            <br></br>
            <h3>Member of</h3>
            <p></p>
            <p></p>
          </div>
          <div class="row justify-xs-content-center">
            <div class="col-auto">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src="img/acm.png" height="50px" alt="" />
                      </div>
                    </th>
                    <td>
                      {" "}
                      <div className="caption">
                        <p>Association for Computing Machinery</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src="img/had.png" height="50px" alt="" />
                      </div>
                    </th>
                    <td>
                      {" "}
                      <div className="caption">
                        <p>Acoustical Society of Croatia</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <div>
                        <img src="img/ngs.png" height="50px" alt="" />
                      </div>
                    </th>
                    <td>
                      {" "}
                      <div className="caption">
                        <p>National Geographic Society</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
